module.exports = __webpack_public_path__ + "static/media/Circo2025_14.87c4d5e4.webp";